import   sevices   from "./services"

export default {
    services: {
        accounts: sevices.accounts,
        chatbot: sevices.chatbot,
        statistics: sevices.statistics,
        statuses: sevices.statuses,
        tags: sevices.tagz,
        workspaces: sevices.workspaces,
        workspaceusers: sevices.workspaceusers,
        user: sevices.user,
        messages: sevices.messages,
        networks: sevices.networks,
        slack: sevices.slack,
        canny: sevices.canny,
        stripe: sevices.stripe,
        subscriptions: sevices.subscriptions,
        feeds: sevices.feeds,
        base64: sevices.base64,
        notes: sevices.notes,
        assignments: sevices.assignments,
        cannedResponses: sevices.cannedResponses,
        automationRules: sevices.automationRules,
        notifications: sevices.notifications
    }
}


// WEBPACK FOOTER //
// ./src/libs/system/index.js